import React, { useEffect, useState } from "react";
import { useOutletContext, useParams } from "react-router-dom";
import { extractMatricDigits, extractClassesTeachers } from "../../AppManager";
import MemberCard from "../../components/MemberCard";
import EmptySearch from "../../components/EmptySearch";

function AdminTeachers() {
  const { record } = useOutletContext();
  const { Class } = useParams();
  const [teachers, setTeachers] = useState([]);

  useEffect(() => {
    extractClassesTeachers(Class)
      .then((data) => setTeachers(data))
      .catch((err) => err);
  }, [record, Class]);

  document.title = `${Class} Teachers`;

  const teachersElements = teachers.map((dat) => (
    <MemberCard
      key={dat.matric + dat.class}
      name={dat.name}
      image={dat.image}
      matric={dat.matric}
      to={extractMatricDigits(dat.matric)}
      imgfolder="teachers"
    />
  ));

  return (
    <div className="overview-students">
      <h1 className="heading1" style={{ width: "100vw" }}>
        {Class} Teachers
      </h1>
      {teachersElements.length === 0 ? (
        <EmptySearch message={"No Teacher Found"} />
      ) : (
        teachersElements
      )}
    </div>
  );
}

export default AdminTeachers;
